(function () {
  function initProductGalleryArrows() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.dataset.pgaInit) return;

      var thumbs = gallery.querySelectorAll('.thumbnail-list .thumbnail');
      if (thumbs.length < 2) return;

      var viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
      if (!viewer) return;

      if (window.getComputedStyle(viewer).position === 'static') {
        viewer.style.position = 'relative';
      }

      function buildArrow(direction) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pga-arrow pga-arrow--' + direction;
        btn.setAttribute('aria-label', direction === 'prev' ? 'Previous image' : 'Next image');
        btn.innerHTML = direction === 'prev'
          ? '<svg viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>'
          : '<svg viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
        return btn;
      }

      var prevBtn = buildArrow('prev');
      var nextBtn = buildArrow('next');
      viewer.appendChild(prevBtn);
      viewer.appendChild(nextBtn);

      function currentIndex() {
        var idx = 0;
        thumbs.forEach(function (t, i) {
          if (t.getAttribute('aria-current') === 'true') idx = i;
        });
        return idx;
      }

      function goTo(step) {
        var next = (currentIndex() + step + thumbs.length) % thumbs.length;
        thumbs[next].click();
      }

      prevBtn.addEventListener('click', function () { goTo(-1); });
      nextBtn.addEventListener('click', function () { goTo(1); });

      gallery.dataset.pgaInit = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGalleryArrows);
  } else {
    initProductGalleryArrows();
  }

  document.addEventListener('shopify:section:load', initProductGalleryArrows);
})();